// PlannerEmptyTimelineMessage.js

import { Box, Typography } from "@mui/material";

export default function PlannerEmptyTimelineMessage({ hasClasses = false }) {
  return (
    <Box
      sx={{
        p: 3,
        textAlign: "center",
      }}
    >
      <Typography variant="body1" fontWeight={600}>
        Du hast noch keine Projekte.
      </Typography>

      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {hasClasses
          ? "Wähle oben eine Klasse aus, um dein erstes Projekt zu erfassen oder bestehende Projekte dieser Klasse zu sehen."
          : "Du hast noch keine Klassen ausgewählt. Öffne zuerst den Bereich «Klassen» und wähle die von dir unterrichteten Klassen aus (Achtung, es werden die gleichen Klassen angezeigt, wie im BSZ Finder!)."}
      </Typography>
    </Box>
  );
}
